import React from 'react';
import { useTranslation } from 'react-i18next';

import { Typography, Tooltip } from '@utex/ui-kit';
import { Container, TitleWrapper } from './styles';

interface Props {
  menu: JSX.Element;
  currentItem: JSX.Element;
}

export const MobileMenu = (props: Props) => {
  const { t } = useTranslation('deposit');

  return (
    <Tooltip
      on="click"
      position="top"
      width={284}
      offset={8}
      isArrow={false}
      padding={[0, 0, 25]}
      isClosable={true}
      trigger={props.currentItem}
    >
      {(onRequestClose) => (
        <Container>
          <TitleWrapper>
            <Typography.Text size="L" lh="L" weight="bold">
              {t('Deposit Method')}
            </Typography.Text>
          </TitleWrapper>
          <div onClick={() => onRequestClose()}>{props.menu}</div>
        </Container>
      )}
    </Tooltip>
  );
};
